import { useSelector } from 'react-redux';

 
import { getCurrentChainBalances } from '../../redux/selectors';

type CurrentChainBalances = {
  wallet: Partial<Record<string, string>>;
  imaginary: Partial<Record<string, string>>;
  contract: Partial<Record<string, string>>;
  available: Partial<Record<string, string>>;
  allowance: Partial<Record<string, string>>;
  locked: {
    local: {
      swapThroughOrionPool: Partial<Record<string, string>>;
      atomic: {
        pending: Partial<Record<string, string>>;
        active: Partial<Record<string, string>>;
      };
    };
    external: { aggregator: Partial<Record<string, string>> };
  };
};

export function useCurrentChainBalances(): CurrentChainBalances | null {
  const balances = useSelector(getCurrentChainBalances);

  return balances;
}
